import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaCheckboxComponent } from './eva-checkbox.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    EvaCheckboxComponent
  ],
  imports: [ 
    CommonModule,
    FormsModule
  ],
  exports: [
    EvaCheckboxComponent
  ],
  providers: [],
})
export class EvaCheckboxModule {}